import { Component, Input, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoModule } from '@ngneat/transloco';

import {
    ApexChart,
    ApexAxisChartSeries,
    ChartComponent,
    ApexDataLabels,
    ApexPlotOptions,
    ApexYAxis,
    ApexXAxis,
    ApexLegend,
    ApexGrid,
    NgApexchartsModule
} from "ng-apexcharts";

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    dataLabels: ApexDataLabels;
    plotOptions: ApexPlotOptions;
    yaxis: ApexYAxis;
    xaxis: ApexXAxis;
    grid: ApexGrid;
    colors: string[];
    legend: ApexLegend;
};
@Component({
    selector: 'app-http-status',
    standalone: true,
    imports: [MatCardModule, NgApexchartsModule, TranslocoModule],
    templateUrl: './http-status.component.html',
    styleUrl: './http-status.component.scss'
})
export class HttpStatusComponent {

    @ViewChild("chart") chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    @Input() data: any = {
        labels: [],
        series: [],
        colors: [],
    };

    constructor() {
        this.chartOptions = {
            series: [
                {
                    name: "Subdomains",
                    data: this.data.series
                }
            ],
            chart: {
                height: 350,
                type: "bar",
                events: {
                    click: function (chart, w, e) {
                        // console.log(chart, w, e)
                    }
                }
            },
            colors: this.data.colors,
            plotOptions: {
                bar: {
                    columnWidth: "45%",
                    distributed: true
                }
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false,
            },
            xaxis: {
                categories: this.data.labels,
                labels: {
                    style: {
                        colors: this.data.colors,
                        fontSize: '12px'
                    }
                }
            }
        };
    }

    // changeData
    changeData() {
        this.chartOptions = {
            series: [
                {
                    name: "Subdomains",
                    data: this.data.series
                }
            ],
            chart: {
                height: 350,
                type: "bar",
                events: {
                    click: function (chart, w, e) {
                        // console.log(chart, w, e)
                    }
                }
            },
            colors: this.data.colors,
            plotOptions: {
                bar: {
                    columnWidth: "45%",
                    distributed: true
                }
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false,
            },
            xaxis: {
                categories: this.data.labels,
                labels: {
                    style: {
                        colors: this.data.colors,
                        fontSize: '12px'
                    }
                }
            }
        };
    }

}
